/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */

import {
  getProjectPrefix, getAppTheme
} from '../config/utils';
import { appThemes } from '../config/const';

export const getSpriteUrl = () => {
  const ComponentSVG = require(`./images/${ getProjectPrefix() }/generated_sprites.svg`);
  return ComponentSVG;
};

export const getPurchaseSpriteUrl = () => {
  const theme = getAppTheme() || appThemes.light;
  const ComponentSVG = require(`./images/${ getProjectPrefix() }/generated_payments_${ theme }_sprites.svg`);
  return ComponentSVG;
};

// Cache for loaded sprites and their URLs
const spriteCache = new Map<string, string>();
const loadedContainers = new Set<string>();

/**
 * Ensures a hidden sprite container with the given ID exists in document.body.
 * Creates and appends it if missing — this avoids duplicate-ID issues and
 * guarantees the container survives component unmount/remount cycles.
 */
const ensureSpriteContainer = (containerId: string): HTMLElement | null => {
  if (typeof document === 'undefined') return null;

  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    container.style.position = 'absolute';
    container.style.top = '-1500px';
    document.body.appendChild(container);
  }
  return container;
};

export const loadSVGSprite = async (url: string, containerId: string) => {
  try {
    const container = ensureSpriteContainer(containerId);
    if (!container) {
      return;
    }

    const currentContent = container.innerHTML.trim();

    // Check if sprites are already loaded in this container
    const containerKey = `${ containerId }-${ url }`;
    if (loadedContainers.has(containerKey) && currentContent.length > 50) {
      return;
    }

    // Check cache
    let svgSprite = spriteCache.get(url);

    if (!svgSprite) {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${ response.status }`);
      }

      svgSprite = await response.text();
      spriteCache.set(url, svgSprite);
    }

    // Insert content only if container is empty or has little content
    if (currentContent.length < 50) {
      container.innerHTML = svgSprite;
      loadedContainers.add(containerKey);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('❌ ~ Error loading SVG sprite:', error);
  }
};
